import { io } from 'socket.io-client';
import { getBackendUrl } from '../utils/config';
import { ACADEMY_AUTH_TOKEN_KEY, ACADEMY_AUTH_USER_KEY } from '../utils/authStorage';

class SocketService {
    constructor() {
        this.socket = null;
    }

    connect(token) {
        if (this.socket && this.socket.connected) {
            return;
        }

        const backendUrl = getBackendUrl();
        console.log(`[SOCKET] Connecting to ${backendUrl}`);

        this.socket = io(backendUrl, {
            auth: { token },
            transports: ['websocket', 'polling']
        });

        this.socket.on('connect', () => {
            console.log('[SOCKET] Connected successfully');
        });

        this.socket.on('connect_error', (err) => {
            console.error('[SOCKET] Connection error:', err);
        });

        this.socket.on('force_logout', (data) => {
            console.warn('[SOCKET] Force logout event received:', data.reason);
            
            // Clear auth token & user
            localStorage.removeItem(ACADEMY_AUTH_TOKEN_KEY);
            localStorage.removeItem(ACADEMY_AUTH_USER_KEY);
            
            this.disconnect();
            
            // Redirect to login page with reason
            window.location.href = '/login?reason=session_expired';
        });
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
            console.log('[SOCKET] Disconnected');
        }
    }
}

export const socketService = new SocketService();
